import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";

const EditMerchantComponent = loadable(
  () => import("../../components/Merchant/EditMerchant")
);
const EditMerchant = () => {
  const { id } = useParams()

  const { data: merchant, refetch, isLoading } = useGetHook({
    queryKey: [`merchant-${id}`],
    url: `${APIS.MERCHANT}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["merchant"],
    navigateURL: "/merchant",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.MERCHANT}${id}/`;
    let formData = {
      ...values,
      "service_type": values?.service_type ? values?.service_type?.map((item: any, index: number) => (item?.value)) : [],
      "product_type": values?.product_type ? values?.product_type?.map((item: any, index: number) => (item?.value)) : [],
      "service_city": values?.service_city ? values?.service_city?.map((item: any, index: number) => (item?.value)) : [],
      "service_branch": values?.service_branch ? values?.service_branch?.map((item: any, index: number) => (item?.value)) : [],
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Merchant ({merchant?.name}) </span>
      </div>
      {isLoading ? <Spinner /> :
        <EditMerchantComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          profile={merchant}
          refetch={refetch}
        />
      }
    </>
  );
};
export default EditMerchant;
